import FeatSDKV1, { CardTransactionResponseV1 } from 'api/version1';
import FeatSDKV3 from 'api/version3';
import { BaseErrorResponse } from 'api/base';
import { createEffect } from 'effector';
import { PaymentType } from 'models';

type RetryPaymentType = Exclude<PaymentType, 'BONUS' | 'SBERPAY'>;

type RetryOrderPaymentParams = {
  orderId: string;
  amount: number;
  paymentType: RetryPaymentType;
  paymentCardId: string | null;
};

type RetryOrderPaymentResult = {
  url: string | undefined;
};

const transactionMethods = {
  CASH: FeatSDKV1.transactions.cash,
  TERMINAL: FeatSDKV1.transactions.terminal,
  CARD: FeatSDKV1.transactions.card,
  SAVED: FeatSDKV1.transactions.saved,
  SBP: FeatSDKV1.transactions.sbp,
} as const;

export const retryOrderPaymentFx = createEffect<
  RetryOrderPaymentParams,
  RetryOrderPaymentResult,
  BaseErrorResponse.ErrorResponse
>(async ({ orderId, amount, paymentType, paymentCardId }) => {
  await FeatSDKV3.orders.paymentRetry(orderId);

  const transactionResponse =
    paymentType === 'SAVED'
      ? await transactionMethods.SAVED({
          orderId,
          amount,
          paymentCardId: paymentCardId!,
        })
      : await transactionMethods[paymentType]({
          orderId,
          amount,
        });

  return {
    url:
      paymentType === 'CARD' || paymentType === 'SBP'
        ? (transactionResponse as CardTransactionResponseV1).url
        : undefined,
  };
});
